// RxJs
import { SubscriptionLike } from 'rxjs';

/**
 * Subscription barrel that holds Observable subscriptions
 * until you call unsubscribe on it in ngOnDestroy.
 */
export class SubscriptionBarrel {
  protected _subs: SubscriptionLike[] = [];

  /**
   * Subscription barrel that holds Observable subscriptions
   * until you call unsubscribe on it in ngOnDestroy.
   *
   * @example
   * In Angular:
   * ```
   *   private subs = new SubscriptionBarrel();
   *   ...
   *   this.subs.barrel = observable$.subscribe(
   *   this.subs.add(observable$.subscribe(...));
   *   ...
   *   ngOnDestroy() {
   *     this.subs.unsubscribe();
   *   }
   * ```
   */

  /**
   * Add subscriptions to the tracked subscriptions
   * @example
   *  this.subs.add(observable$.subscribe(...));
   */
  public add(...subscriptions: SubscriptionLike[]): void {
    this._subs = this._subs.concat(subscriptions);
  }

  /**
   * Assign subscription to this barrel to add it to the tracked subscriptions
   * @example
   *  this.subs.barrel = observable$.subscribe(...);
   */
  public set barrel(subscription: SubscriptionLike) {
    this._subs.push(subscription);
  }

  /**
   * Unsubscribe to all subscriptions in ngOnDestroy()
   * @example
   *   ngOnDestroy() {
   *     this.subs.unsubscribe();
   *   }
   */
  public unsubscribe(): void {
    this._subs.forEach(sub => sub && sub.unsubscribe());
    this._subs = [];
  }
}
